"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_get_1 = __importDefault(require("lodash.get"));
function getValue(data, field) {
    if (field.startsWith('/')) {
        return lodash_get_1.default(data.original, field.substr(1));
    }
    return data.tip[field];
}
exports.getValue = getValue;
